export const OFFLINE_MAX_MS = 30 * 60 * 1000;
export const OFFLINE_QUEUE_LIMIT = 100;

export function offlineLessonOpen(args: {
  startedAt: number;
  now: number;
  entitlementExpiresAt?: number | null;
  completed?: boolean;
}): boolean {
  if (args.completed) return false;
  if (args.now - args.startedAt > OFFLINE_MAX_MS) return false;
  if (args.entitlementExpiresAt && args.now >= args.entitlementExpiresAt) return false;
  return true;
}

export function canEnqueueOffline(queueLength: number): boolean {
  return queueLength < OFFLINE_QUEUE_LIMIT;
}
